enum ReportingCancelStatus {
    ALL = "ALL",
    NOT_CANCELLED = "NOT_CANCELLED",
    CANCELLED = "CANCELLED",
}

export default ReportingCancelStatus;